var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationsOff = function SvgNotificationsOff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.15 19H5a.97.97 0 0 1-.712-.288A.97.97 0 0 1 4 18q0-.424.288-.712A.97.97 0 0 1 5 17h1v-7q0-.825.213-1.625A6 6 0 0 1 6.85 6.85l1.5 1.5A4.025 4.025 0 0 0 8 10v7h6.2L2.1 4.9a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l17 17q.275.275.288.688a.93.93 0 0 1-.288.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275zM18 15.15l-2-2V10q0-1.65-1.175-2.825T12 6q-.65 0-1.25.2a3.5 3.5 0 0 0-1.1.6L8.2 5.35q.5-.4 1.075-.7T10.5 4.2v-.7q0-.625.438-1.062A1.45 1.45 0 0 1 12 2q.624 0 1.063.438.437.436.437 1.062v.7q2 .5 3.25 2.113T18 10zM12 22q-.825 0-1.412-.587A1.93 1.93 0 0 1 10 20h4q0 .824-.588 1.413A1.93 1.93 0 0 1 12 22"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationsOff);
export { ForwardRef as ReactComponent };